module.exports = __webpack_public_path__ + "img/1.3fa26790.png";